import { Component, OnInit, Injector } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';
import { SeoAwareBaseComponent } from '../common-theme/seo/seo-aware-base.component';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./facilities.component.scss']
})

export class HistoryComponent extends SeoAwareBaseComponent implements OnInit {
  public reasons: any[] = [];
  translateSubscription: Subscription = new Subscription();
  subscription: Subscription = new Subscription();

  constructor(
    public injector: Injector,
    public translateService: TranslateService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.setTitle('Istoria Dream Residence în cartierul nou Rahova');
    this.meta.addTags([
      { name: 'robots', content: 'noindex' }
    ]);

    this.setMetaDescription(`
      Dream Residence s-a născut din dorința de a face ceva diferit și din a crea un “acasă” perfect pentru fiecare rezident.
      Astăzi găzduim locatari în 935 de apartamente în cartierul nou Rahova.
    `);
  }
}



// WEBPACK FOOTER //
// ./src/app/about-us/history.component.ts